document.addEventListener("DOMContentLoaded", () => {
  // 階層型のチェックボックスで一括チェック
  document.querySelectorAll(".js-narrow-down-check").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const wrapper = this.closest(".js-narrow-down-item");
      if (!wrapper) return;
      // 対象の下位チェックを全切り替え
      const childCheckboxes = wrapper.querySelectorAll(".js-narrow-down-check");
      childCheckboxes.forEach((childCheckbox) => {
        childCheckbox.checked = this.checked;
      });

      // 同列のチェック状況で上位のチェックを切り替え
      let currentElement = wrapper;
      while (currentElement) {
        const parentItem = currentElement.parentElement?.closest(".js-narrow-down-item");
        if (!parentItem) break;

        const checkboxes = parentItem.querySelectorAll("[class*='p-users-keywords__item'] .js-narrow-down-check");
        const checkedSiblings = parentItem.querySelectorAll("[class*='p-users-keywords__item'] .js-narrow-down-check:checked");
        const allChecked = checkboxes.length === checkedSiblings.length;

        const parentCheckbox = parentItem.querySelector(":scope > .js-narrow-down-check");
        if (parentCheckbox) {
          parentCheckbox.checked = allChecked;
        }
        currentElement = parentItem;
      }
    });
  });

  // 選択中のアイテムをクリア
  document.querySelectorAll(".js-narrow-clear-area").forEach((button) => {
    button.addEventListener("click", () => {
      const targetArea = document.getElementById("target-search-area");
      if (targetArea) {
        const checkboxes = targetArea.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
      const form = document.getElementById("js-narrow-form");
      if (form) {
        form.submit();
      }
    });
  });

  document.querySelectorAll(".js-narrow-clear-keyword").forEach((button) => {
    button.addEventListener("click", () => {
      const targetKeyword = document.getElementById("target-search-keyword");
      if (targetKeyword) {
        const checkboxes = targetKeyword.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
      const form = document.getElementById("js-narrow-form");
      if (form) {
        form.submit();
      }
    });
  });

  document.querySelectorAll(".js-narrow-clear-type").forEach((button) => {
    button.addEventListener("click", () => {
      const targetType = document.getElementById("target-search-type");
      if (targetType) {
        const checkboxes = targetType.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
      const form = document.getElementById("js-narrow-form");
      if (form) {
        form.submit();
      }
    });
  });

  // カタリスト計測
  document.querySelectorAll(".js-narrow-clipchoice").forEach((button) => {
    button.addEventListener("click", (event) => {
      const target = event.target;
      const clipchoice = target.dataset.clipchoice;
      // eslint-disable-next-line no-undef
      onclickcatalyst_clipchoice(target, clipchoice);
    });
  });
});
